import { render, staticRenderFns } from "./DialogWelcome.vue?vue&type=template&id=7e135af2&scoped=true"
import script from "./DialogWelcome.js?vue&type=script&lang=js&external"
export * from "./DialogWelcome.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e135af2",
  null
  
)

export default component.exports